import { openBlock as t, createElementBlock as e, createElementVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ l("path", {
  fill: "#FFDA44",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), h = /* @__PURE__ */ l("path", {
  fill: "#0052B4",
  d: "M32.174 9.565c-.18.862-.261 1.78-.261 2.696 0 5.276 3.145 9.843 7.653 11.898.283-1.342.434-2.733.434-4.159C40 8.954 31.046 0 20 0S0 8.954 0 20s8.954 20 20 20c6.85 0 12.895-3.445 16.5-8.696H11.304v-2.608h26.711c.274-.566.52-1.146.741-1.74H11.304l20.87-17.39Z"
}, null, -1), c = /* @__PURE__ */ l("path", {
  fill: "#F0F0F0",
  d: "m14.693 10.435.432 1.328h1.397l-1.13.822.431 1.328-1.13-.82-1.13.82.432-1.328-1.13-.822h1.396l.432-1.328ZM9.019 20l.54 1.66h1.745l-1.412 1.027.54 1.66-1.413-1.026-1.413 1.027.54-1.66-1.413-1.027h1.746L9.019 20Zm0-13.913.54 1.66h1.745L9.892 8.775l.54 1.66-1.413-1.026-1.413 1.027.54-1.661-1.413-1.026h1.746l.54-1.661ZM4.67 13.913l.54 1.66h1.746L5.544 16.6l.54 1.66-1.413-1.026-1.413 1.027.54-1.66-1.413-1.027h1.746l.54-1.66Z"
}, null, -1), s = [
  n,
  h,
  c
];
function d(i, r) {
  return t(), e("svg", o, [...s]);
}
const a = { render: d };
export {
  a as default,
  d as render
};
